// Feature: M004-F0716 (phase B, design 5.2 rows 14, 18). Test: T-M004-0212.
//
// What a billing item's stage says to DO: Core's `next_action` verbatim (or, for a failure stage that arrived without one, the fixed
// "Core did not say what to do next" sentence) and each open condition's own message and next_action verbatim. A condition is
// fixable, never a refusal, so it never takes the problem style. Nothing is authored here beyond the fixed missing-next sentence.
import React from 'react';

const BillingStageLines = ({ view, testidPrefix }) => (
  <>
    {view.nextAction ? (
      <span className={`billpipe-row-next${view.nextMissing ? ' billpipe-row-next-missing' : ''}`} data-testid={`${testidPrefix}-next`}>
        {view.nextAction}
      </span>
    ) : null}
    {view.conditions.map((condition, index) => (
      <span className="billpipe-row-condition" key={`${condition.code}-${index}`} data-testid={`${testidPrefix}-condition`} data-code={condition.code}>
        {condition.message}{condition.nextAction ? ` ${condition.nextAction}` : ''}
      </span>
    ))}
  </>
);

export default BillingStageLines;
